import { cn } from '@magicdoorinc/ui';
import { A } from '@solidjs/router';
import { Show } from 'solid-js';
import { useMenu } from '~/components/layouts/Menu/MenuContext';
import { useFeatureHighlights } from '~/contexts/global';
import type { MainMenuItemProps } from '~/components/layouts/Menu/types/menuItem';
export const MainMenuButton = (props: MainMenuItemProps) => {
  const menu = useMenu();
  const { pulse } = useFeatureHighlights();

  const MenuContent = () => (
    <>
      <span class="relative flex">
        <img
          src={props.item.icon}
          class={cn('size-5', {
            hidden: menu?.isSelected(props.item),
          })}
          alt={props.item.text + ' Icon'}
        />
        <img
          src={props.item.selectedIcon}
          class={cn('size-5', {
            hidden: !menu?.isSelected(props.item),
          })}
          alt={props.item.text + ' Icon'}
        />
        <Show when={props.item.hasHighlight}>
          <span class="absolute -right-1 -top-1 flex size-2">
            <Show when={pulse()}>
              <span class="absolute -inset-0.5 animate-[ping_1.6s_ease-out_infinite] rounded-full bg-orange-400 opacity-75" />
            </Show>
            <span class="relative inline-flex size-2 rounded-full bg-orange-500" />
          </span>
        </Show>
      </span>
      <Show when={!menu?.isManuallyCollapsed() && !menu?.isCollapsed()}>{props.item.text}</Show>
    </>
  );

  const commonClasses = 'flex w-full items-center gap-2 text-left';

  return (
    <div class="flex items-center">
      <Show
        when={props.item.canNavigate}
        fallback={
          <div
            class={commonClasses}
            classList={{
              'font-medium': menu?.isSelected(props.item),
            }}>
            <MenuContent />
          </div>
        }>
        <A id={menu?.getMenuItemId(props.item, true)} href={props.item.replace || props.item.realPath || props.item.path}>
          <button
            class={commonClasses}
            classList={{
              'font-medium': menu?.isSelected(props.item),
            }}>
            <MenuContent />
          </button>
        </A>
      </Show>
    </div>
  );
};
